import { getLabel } from '@components/modules/ProductGrid/Filter/filtering'
import { CustomProductGridTile } from '@features/products/api/get-custom-product-grid-tiles'
import { mapEdgesToItems } from '@utils/map'
import { useMemo } from 'react'

export type Collection = {
  value: string
  label: string
  count?: number
  disabled?: boolean | false
}

export const useFindCollections: (
  products: Partial<CustomProductGridTile>[],
  countProductsOnly?: boolean,
) => {
  collections: Collection[]
} = (products, countProductsOnly) => {
  const collections = useMemo(
    () =>
      [
        ...new Set(
          products
            .map((product) =>
              product.tags
                ?.filter((tag) => tag.startsWith('col_'))
                .map((tag) =>
                  JSON.stringify({
                    name: tag,
                    label:
                      product.name.includes(tag.split('_')[1]) &&
                      product.name.includes('-')
                        ? getLabel(tag)
                        : getLabel(tag).replace(/-/gm, ' '),
                  }),
                ),
            )
            .flat(),
        ),
      ].map((unparsedTag) => {
        if (!unparsedTag) return
        const parsedTag = JSON.parse(unparsedTag)
        return {
          value: parsedTag.name,
          label: parsedTag.label,
          count: products?.reduce(
            (count, product) =>
              product.tags.find((tag) => tag === parsedTag.name)
                ? count +
                  (false
                    ? 0
                    : countProductsOnly
                      ? 1
                      : mapEdgesToItems(product.variants)?.length)
                : count,
            0,
          ),
        }
      }),
    [products, countProductsOnly],
  )

  return { collections }
}
